import { IRequest } from '@r1-frontend/shared/types/IRequest';

import { RequestDto } from './dto/RequestDto';

/**
 * @deprecated использовать новую адреску!!!
 */
const getHouseList = (body: RequestDto): IRequest => ({
    uri: '/v1/address/get-house-list',
    method: 'POST',
    withAuth: false,
    withProvider: true,
    body: JSON.stringify(body),
});

export type { RequestDto };

export default getHouseList;
